module.exports = __webpack_public_path__ + "img/desktop_roseapple.34267e78.png";